/* eslint-disable complexity */
/* eslint-disable eslint-comments/disable-enable-pair */

import defaultCustomerData from './defaultCustomerData'

/* eslint-disable max-lines */
const manageOrderItem = (order, items) => items?.map(item => ({
  quantity: item?.modifiers?.quantity || 0,
  orderItemId: item?.product?.productId,
  orderId: order?.orderId,
  sku: item?.product?.sku,
  skuNumber: item?.product?.sku,
  qty: item?.modifiers?.quantity || 0,
  listPrice: item?.price?.regular,
  corePrice: item?.price?.core || 0.00,
  total: Number(item?.total?.price || 0).toString(),
  warrantyPrice: item?.modifiers?.warranty ? item?.warranty?.customerProtectionPlan?.price : 0.00,
  warrantyCode: item?.modifiers?.warranty ? item?.warranty?.customerProtectionPlan?.code : '',
  productId: item?.product?.productId.toString(),
  shipping: item?.product?.shipping,
  handling: item?.product?.handling,
  httpReferer: item?.referer,
  itemTotalCore: (item?.price?.core || 0.00) * (item?.modifiers?.quantity || 0),
  itemWarrantyCode: item?.modifiers?.warranty ? item?.warranty?.customerProtectionPlan?.code : '',
  itemWarrantyAmount: item?.modifiers?.warranty ? item?.warranty?.customerProtectionPlan?.price : 0.00,
  itemTotalWarranty: item?.modifiers?.warranty
    ? item?.warranty?.customerProtectionPlan?.price *
    (item?.modifiers?.quantity || 0) : 0.00,
  pVendor: item?.product?.brand?.name,
  shippingFactor: item?.product?.shippingFactor,
  productText: item?.product?.part?.name,
  partname: item?.product?.part?.name,
  part: item?.product?.part?.name,
  skuTitle: item?.modifiers?.vehicle?.isFit && item?.modifiers?.vehicle?.product?.title ?
    item?.modifiers?.vehicle?.product?.title : item?.product?.title,
  title: item?.modifiers?.vehicle?.isFit && item?.modifiers?.vehicle?.product?.title ?
    item?.modifiers?.vehicle?.product?.title : item?.product?.title,
  description: item?.product?.description,
  displayTitle: item?.product?.title,
  brand: item?.product?.brand?.name,
  brandText: item?.product?.brand?.name,
  category: item?.product?.category,
  categorytext: item?.product?.category,
  imageUrl: item?.product?.image?.url,
  image: item?.product?.image?.url,
  quantitySold: item?.product?.quantitySold,
  mfr_number: item?.product?.sku,
  position: item?.product?.position,
  product_attributes: item?.product?.productAttr,
  customerProtectionPlan: item?.warranty?.customerProtectionPlan,
  vehicle: item?.modifiers?.vehicle?.details ||
    {
      year: '',
      make: '',
      model: '',
      submodel: '',
      engine: '',
    },
  isVehicleFit: item?.modifiers?.vehicle?.isFit || false,
  isUniversal: (item?.product?.isUniversal && !item?.modifiers?.vehicle?.lockedFitment) || false,
  isFreeShipping: item?.inventory?.shipping?.type?.toLowerCase() === 'free' || false,
  isFreeShippingForMembers: item?.inventory?.membershipShippingType?.toLowerCase() === 'free' || false,
  itemTotalAmount: Number(item?.total?.price || 0),
  itemTotalUnitPrice: Number(((item?.price?.regular || 0.00) * (item?.modifiers?.quantity || 0)) || 0),
  difm: item?.modifiers?.difm || null,
  shippingExpectations: item?.modifiers?.shippingExpectation,
  deliveryType: item?.shippingOption?.options?.find((o: any) => o?.method === item?.modifiers?.shippingMethod)?.deliveryType || null,
  shippingMethod: item?.modifiers?.shippingMethod,
  lifetimeReplacement: item?.product?.lifetimeReplacement,
  productProtection: item?.modifiers?.productProtection,
  productProtectionPlans: item?.productWarranty?.productProtectionPlan,
  marketing: item?.productWarranty?.marketing,
  isPlBrand: item?.product?.isPlBrand || false,
  vendorId: item?.shippingOption?.vendor?.id || '',
  shippingOptions: item?.shippingOption?.options || [],
  referrer: item?.referrer,
  ...(item?.referrerUrl && { referrerUrl: item?.referrerUrl }),
  pricingStatus: item?.product?.pricingStatus || {},
  ...item?.shippingOption?.vendor?.hasUnfoldedOptions && { hasUnfoldedOptions: item?.shippingOption?.vendor?.hasUnfoldedOptions },
  notes: item?.notes,
  ...item?.product?.catalogType && { catalogType: item?.product?.catalogType },
}))

const getCouponCode = coupon => {
  const { code } = coupon?.discounts?.find(discount => discount.applied === true) || {}
  return code || ''
}

const getItemSkuDiscount = coupon => {
  const { itemSku } = coupon?.discounts?.find(discount => discount.applied === true) || {}
  return itemSku || null
}

const manageCouponMessage = order => (
  order?.couponMsg
    ? {
      couponMsg: order?.couponMsg,
    }
    : {}
)

const manageOrderSummary = (cartId, summary) => ({
  subtotal: summary?.subTotal,
  estSubTotal: summary?.estSubTotal,
  total: summary?.total,
  estTotal: summary?.estTotal,
  totalCorePrice: summary?.coreTotal,
  totalCore: summary?.coreTotal,
  totalDiscount: summary?.coupon?.discount,
  totalEstShipping: summary?.shipping?.cost,
  totalHandling: summary?.handling?.estimated,
  totalShipping: summary?.shipping?.estimated,
  totalShippingDiscount: summary?.shipping?.discount,
  totalTax: summary?.taxTotal,
  totalWarranty: summary?.warrantyTotal,
  totalQuantity: summary?.quantityTotal,
  totalShippingProtection: summary?.shippingProtectionTotal,
  totalProductProtection: summary?.warrantyProductTotal,
  cartId,
})

const manageOrderDetail = order => ({
  cartId: order?.cartId,
  orderId: order?.orderId,
  orderDate: order?.dateCreated,
  lastModified: order?.dateUpdated,
  totalCore: order?.summary?.coreTotal,
  totalTax: order?.summary?.taxTotal,
  totalShipping: order?.summary?.shipping?.estimated,
  totalHandling: order?.summary?.handling?.estimated,
  totalWarranty: order?.summary?.warrantyTotal,
  totalDiscount: order?.summary?.coupon?.discount,
  subTotal: order?.summary?.subTotal,
  estSubTotal: order?.summary?.estSubTotal,
  total: order?.summary?.total,
  estTotal: order?.summary?.estTotal,
  customerId: order?.customerId,
  couponCode: getCouponCode(order?.modifiers?.coupon),
  couponDiscountSku: getItemSkuDiscount(order?.modifiers?.coupon),
  userAgent: order?.userAgent,
  cart_id: order?.cartId,
  items: manageOrderItem(order, order?.items) || [],
  espp: order?.modifiers?.espp || null,
  payment: order?.payment,
  summary: manageOrderSummary(order?.cartId, order?.summary),
  isCblZipState: order?.tax?.isCbl?.toString(),
  merchantOrderId: `${order?.merchantId}${order?.orderId}`,
  shipNot: order?.shipNot || [],
  shipment: order?.shipment || null,
  customer: order?.customer ? { ...defaultCustomerData, ...order?.customer } : null,
  persistEsppSelection: order?.persistEsppSelection || false,
  hasActiveMembership: order?.modifiers?.membership?.hasActiveMembership || false,
  ...manageCouponMessage(order),
  shippingAdjustment: order?.shippingAdjustment ? { ...order?.shippingAdjustment } : null,
  ...order?.modifiers?.featureFlags?.find((flag: any) => flag.name === 'isDynamicShippingEnabled') && { isDynamicShipping: order?.modifiers?.featureFlags?.find((flag: any) => flag.name === 'isDynamicShippingEnabled')?.value },
})

const convertToOldStructureOrderData = order => ({
  order: manageOrderDetail(order),
  orderItems: manageOrderItem(order, order?.items) || [],
})

export default convertToOldStructureOrderData
